import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TablePaginationActions from '../../presentational/table-pagination-actions';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import AuthHelper from '../../../libraries/auth-helper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { history } from '../../../shared/configure-store';
import { toast, ToastContainer } from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import Api from '../../../libraries/api';
import language from '../../../libraries/label-lang';
import { bindActionCreators } from 'redux';
import { RootActions } from '../../../shared/root-action';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import {Selector} from "../styling";

class Products extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            loadingButton: false,

            errors: [],

            showDialog: false,
            idDelete: '',
            currDelete: '',

            orderBy: '',
            sortedBy: 'category',
            searchBy: '',

            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,

            warehouses: [],

            userName: '',
            statusFilter: [],
            statusPast: false,
            classes: [],
            plans: [],

            listKategori:[

                { id:'Beras', name:'Beras'},
                { id:'Bumbu Dan Sambal', name:'Bumbu Dan Sambal'},
                { id:'Daging Ayam', name:'Daging Ayam'},
                { id:'Daging Sapi', name:'Daging Sapi'},
                { id:'Es Krim', name:'Es Krim'},
                { id:'Ikan Dan Hasil Laut', name:'Ikan Dan Hasil Laut'},
                { id:'Makanan Siap Masak', name:'Makanan Siap Masak'},
                { id:'Makanan Siap Saji', name:'Makanan Siap Saji'},
                { id:'Minuman', name:'Minuman'},
                { id:'Oleh-Oleh', name:'Oleh-Oleh'},
                { id:'Roti Dan Kue', name:'Roti Dan Kue'},
                { id:'Selai Dan Mentega', name:'Selai Dan Mentega'},
                { id:'Lainnya', name:'Lainnya'}
            ],
            importSku:false,
            category:''
        };
    }

    componentDidMount() {

        document.title = 'Fresh Factory - Tenants';
        let data = AuthHelper.getProfile();

        this.setState({
            data: data,
        }, () => this.__fetchData(false));


        // detect props state ada
        if (this.props.history.location.state &&
            this.props.history.location.state.msg === 'deleted') {
            this.showMessage(true, 'Success menghapus produk')
        }
    };

    __fetchData = (update) => {
        this.setState({
            loading: true,
        });

        // let page = update ? parseInt(this.state.currentPage + 1) : this.state.currentPage;

        const { sortedBy: sortedBy, orderBy: orderBy, searchBy: searchBy, currentPage: currentPage, category:category, perPage:perPage} = this.state

        const params = new URLSearchParams({
            ...(perPage ? { limit:Number(perPage) } : {}),
            ...(orderBy ? { orderBy } : {}),
            ...(searchBy ? { searchBy } : {}),
            ...(sortedBy ? { sortedBy:sortedBy } : {}),
            ...(currentPage ? { page: Number(currentPage) } : {}),
            ...(category ? { category:category } : {}),
        }).toString();

        // console.log('serch',params)

        Api.get(`/products?${params}`).then(resp => {
            if (resp.data) {

                this.setState({
                    rows: resp.data,
                    perPage: resp.meta.pagination.per_page,
                    currentPage: resp.meta.pagination.current_page,
                    currentPageTable: resp.meta.pagination.current_page - 1,
                    total: resp.meta.pagination.total,
                    loading: false,
                })

            }
        }).catch(err => {
            console.log(err);

            this.setState({
                loading: true,
            }
            );

        });
    };

    handleChange(e, prop) {

        this.setState({

            [prop]: e.target.value

        })

    };


    handleOpen = (row) => {
        this.setState({
            showDialog: true,
            idDelete: row.id,
            currDelete: row.name,
        })
    };

    handleClose = () => {
        this.setState({
            showDialog: false,
        })
    };

    handleDelete = () => {

        if (this.state.idDelete) {
            Api.delete('/products/' + this.state.idDelete, '', false).then(resp => {

                this.setState({
                    showDialog: false,
                }
                );

                this.showMessage(true, 'Successfully deleted');
                this.__fetchData(false);

            }).catch(err => {

                this.setState({
                    showDialog: false
                }
                );

                this.showMessage(true, 'Successfully deleted');
                this.__fetchData(false);
            });
        }
    };

    handleGo = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if (status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        } else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleSearch = () => {
        this.__fetchData(false);
    };
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(false);
        }
    };

    handleSort = (val) => {

        let sortedBy = this.state.sortedBy;

        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            if (sortedBy && sortedBy === 'asc') {
                sortedBy = 'desc';
            } else {
                sortedBy = 'asc';
            }
        }

        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage: newPage + 1,
            currentPageTable: newPage + 1,
            loading: true,
        }, () => {
            this.__fetchData(true);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            perPage: parseInt(event.target.value, 10),
            currentPage: 1,
            loading: true,
        }, () => {
            this.__fetchData(false);
        });
    };

    __handleSearchEvent = (data,props)=>{

        this.setState({
            [props]:data ? data : ''
        },()=> {
            if (props == 'category' && data) {
                this.setState({
                    importSku:true
                },()=>{
                    this.__fetchData();
                });
            } else {
                this.setState({
                    importSku:false,
                },()=>{
                    this.__fetchData();
                })
            }
        });
    };


    formatStorage = (name) => {
        if(name === 'Frozen') {
            return 'Beku';
        }else if(name === 'Chilled') {
            return 'Dingin';
        }else if(name === 'Dry') {
            return 'Kering';
        }
    };


    render() {
        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>{text.label_products}</li>
                    </ol>
                </nav>
                <h2 className='text-uppercase'>{text.label_products}
                    <Button
                        variant='contained'
                        color='primary'
                        className='float-right'
                        onClick={() => this.handleGo('/products/add')}
                    >
                        {text.button_add} {text.label_products}
                    </Button>
                </h2>
                <div className='d-inline-flex align-items-center w-100 justify-content-between my-2'>
                    <span></span>
                    <div className='d-inline-flex align-items-center justify-content-between'>
                        <Selector
                            vertical
                            className="w-100 mr-2"
                            title={text.label_category}
                            value={this.state.searchBy}
                            selected={(x) => this.__handleSearchEvent(x, 'category')}
                            onChange={(x) => this.__handleSearchEvent(x, 'category')}
                            item={this.state.listKategori}
                        />

                        {this.state.importSku && <Button
                            variant='contained'
                            color='primary'
                            className='float-right mb-3'
                            onClick={() => this.handleGo('/products/#')}
                        >
                            Import Sku
                        </Button>}
                    </div>
                </div>

                <div className='clearfix'> </div>
                <div className='table-responsive'>
                    <Table className='table-list' size='small' >
                        <TableHead>
                            <TableRow>
                                <TableCell className='clickable' onClick={() => this.handleSort('skuNumber')} >{text.label_sku}
                                    {this.state.orderBy === 'skuNumber' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell>{text.label_photo || `Gambar`}</TableCell>
                                <TableCell
                                    style={{ minWidth: 160 }}
                                    className='clickable' onClick={() => this.handleSort('name')} >{text.label_product}
                                    {this.state.orderBy === 'name' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>

                                <TableCell
                                    style={{ minWidth: 160 }}
                                    className='clickable' onClick={() => this.handleSort('category')} >{text.label_category || `category`}
                                    {this.state.orderBy === 'category' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>

                                <TableCell className='clickable' onClick={() => this.handleSort('weight')} >{text.label_weight || `weight`}
                                    {this.state.orderBy === 'weight' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>

                                <TableCell
                                    style={{ minWidth: 160 }}
                                >{text.label_size || `size`}</TableCell>


                                <TableCell
                                    style={{ minWidth: 100 }}
                                    className='clickable' onClick={() => this.handleSort('storage')} >{text.label_storage}
                                    {this.state.orderBy === 'storage' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('shelfLife')} >{text.label_expired || 'expired'}
                                    {this.state.orderBy === 'shelfLife' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('price')} >{text.label_price || 'price'}
                                    {this.state.orderBy === 'price' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                    <i className='fas fa-sort-down'> </i>
                                                )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell
                                    style={{ minWidth: 100 }}
                                >{text.label_action}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.loading ? (
                                <TableRow>
                                    <TableCell colSpan={12} align='center' className='py-5'>
                                        <CircularProgress color='primary' />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                    this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={12} style={{ textAlign: 'center' }}>{text.label_no}</TableCell>
                                        </TableRow>
                                    ) : (
                                            this.state.rows.map(row => (
                                                <TableRow
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={_ => {
                                                        history.push('/products/detail/' + row.id)
                                                    }}
                                                    key={row.id}
                                                    selected={row.selected}>
                                                    <TableCell>{row.skuNumber && row.skuNumber}</TableCell>
                                                    <TableCell>{row.image &&

                                                        <img src={`https://freshfactory-assets.s3.ap-southeast-1.amazonaws.com/${row.image}`}
                                                            style={{ width: 50, height: 50, background: `lightgrey` }} />
                                                    }</TableCell>
                                                    <TableCell>{row.name && row.name}</TableCell>
                                                    <TableCell>{row.category && row.category}</TableCell>
                                                    <TableCell>{row.weight && row.weight}</TableCell>
                                                    <TableCell>{row.lockerSize !== null && row.lockerSize.name}</TableCell>
                                                    <TableCell>{this.formatStorage(row.storage)}</TableCell>
                                                    <TableCell>{row.shelfLife} hari</TableCell>
                                                    <TableCell >
                                                        Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} value={parseFloat(row.price)} decimalScale={0} displayType={'text'} renderText={value => value} />
                                                    </TableCell>
                                                    <TableCell>
                                                        {/*<Link to={'/products/edit/' + row.id} className='btn-icon mr-2'>
                                                            <i className='fas fa-edit'> </i>
                                                        </Link>*/}
                                                        <button className='btn-icon' onClick={(e) => {
                                                            e.stopPropagation();
                                                            this.handleOpen(row)
                                                        }}>
                                                            <i className='fas fa-trash-alt'> </i>
                                                        </button>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )
                                )}

                        </TableBody>
                    </Table>
                </div>

                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component='div'
                    count={this.state.total}
                    rowsPerPage={this.state.perPage}
                    page={this.state.currentPageTable}
                    backIconButtonProps={{
                        'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'next page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>Anda yakin ingin menghapus produk:</DialogTitle>
                    <DialogContent>
                        <p className='text-center'>{this.state.currDelete}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleClose}
                        >
                            {text.button_cancel}
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleDelete}
                            disabled={this.state.loadingButton && 'disabled'}
                        >
                            {text.button_delete}{this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i>}
                        </Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer />
            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Products));
